import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { IBreadCrumbEnvironment } from 'projects/shared/lib/interfaces/environment/breadcrumb/breadcrumb-environment.interface';
import { INavigationEnvironment } from 'projects/shared/lib/interfaces/environment/navigation/navigation-environment.interface';
import { Breadcrumb } from './breadcrumb.models';

@Component({
  selector: 'app-breadcrumb',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  @Input() public itemList?: Breadcrumb[] | undefined;

  public settings?: IBreadCrumbEnvironment | undefined;
  public brandPage?: INavigationEnvironment | undefined;
  public visibleItems: Breadcrumb[] = [];

  public constructor(private router: Router) {
    this.settings = ENVIRONMENT.breadcrumb;
  }

  public ngOnInit(): void {
    if (this.settings?.insertHomeAsRoot) {
      this.brandPage = ENVIRONMENT.brandPage;
    }
    this.processBreadcrumbs();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemList']) {
      this.processBreadcrumbs();
    }
  }

  private processBreadcrumbs(): void {
    if (!this.itemList || this.itemList.length === 0) {
      this.visibleItems = [];
      return;
    }

    let rootText = this.itemList[0].text;
    let distinctPaths: Breadcrumb[][] = [];
    let currentPath: Breadcrumb[] = [];

    for (let item of this.itemList) {
      if (item.text === rootText && currentPath.length > 0) {
        distinctPaths.push(currentPath);
        currentPath = [];
      }
      currentPath.push(item);
    }

    if (currentPath.length > 0) {
      distinctPaths.push(currentPath);
    }

    let activePath = distinctPaths.find(path => {
      let lastItem = path[path.length - 1];
      if (!lastItem?.routerLink) return false;

      return this.router.isActive(lastItem.routerLink, {
        paths: 'exact',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      });
    });

    if (activePath) {
      this.visibleItems = activePath;
    } else {
      distinctPaths.sort((a, b) => b.length - a.length);
      this.visibleItems = distinctPaths[0] || [];
    }
  }
}